import { BoundedCollection, IsBounds } from "../geometry";
import { SpatialTree } from "./tree.spatial";
export class SpatialTreeNode {
    constructor(bounds, depth) {
        this.boundingBox = bounds;
        this.depth = depth ?? 1;
    }
    get isLeaf() {
        return (this.children?.length ?? 0) != 0;
    }
    *[Symbol.iterator](predicate) {
        if (this.children) {
            if (predicate) {
                for (const t of this.children) {
                    if (predicate(t)) {
                        yield t;
                    }
                }
            }
            return this.children;
        }
        return null;
    }
    subdivide(options) {
        if (options.spliter != undefined) {
            const splitBounds = options.spliter.split(this, options);
            if (splitBounds && splitBounds.length > 0) {
                const d = this.depth + 1;
                this.children = splitBounds.map((b) => this.createInstance(options, b, d));
            }
            return;
        }
    }
    lookupToRef(context, bounds, ref) {
        const nodeBox = this.boundingBox;
        const lookupBox = IsBounds(bounds) ? bounds : bounds.boundingBox;
        if (lookupBox == undefined || lookupBox.intersects(nodeBox) == false) {
            return;
        }
        if (this.items) {
            const threshold = context.tree.lookupThreshold ?? SpatialTree.DefaultLookupThreshold;
            if (this.items.length < threshold) {
                const contentBounds = this.items.boundingBox;
                if (lookupBox.intersects(contentBounds) == false) {
                    return;
                }
            }
            for (const v of this.items.data) {
                const dataBox = IsBounds(v) ? v : v.boundingBox;
                if (dataBox && dataBox.intersects(lookupBox)) {
                    ref.push(v);
                }
            }
            return;
        }
        if (this.children) {
            for (const c of this.children) {
                c.lookupToRef(context, bounds, ref);
            }
        }
    }
    _checkBounds(data) {
        const nodeBox = this.boundingBox;
        const accepted = [];
        const indicesToRemove = [];
        for (let i = 0; i < data.length; i++) {
            const v = data[i];
            const dataBox = IsBounds(v) ? v : v.boundingBox;
            if (dataBox?.intersects(nodeBox)) {
                accepted.push(v);
                indicesToRemove.push(i);
            }
        }
        for (let i = indicesToRemove.length - 1; i >= 0; i--) {
            data.splice(indicesToRemove[i], 1);
        }
        return accepted;
    }
    createInstance(ctx, box, depth) {
        const ctor = this.constructor;
        return new ctor();
    }
    add(context, data) {
        const accepted = this._checkBounds(data);
        if (accepted.length == 0) {
            return;
        }
        if (this.children?.length) {
            for (const c of this.children) {
                c.add(context, accepted);
                if (accepted.length == 0) {
                    break;
                }
            }
            return;
        }
        if (this.depth == context.tree.maxDepth) {
            this.items = this.items ?? new BoundedCollection();
            this.items.push(...accepted);
            return;
        }
        if (this.items && this.items.length + accepted.length > context.tree.maxItemPerNode) {
            this.subdivide(context.tree);
            accepted.push(...this.items.data);
            this.items = undefined;
            if (this.children) {
                for (const c of this.children) {
                    c.add(context, accepted);
                    if (data.length == 0) {
                        break;
                    }
                }
            }
        }
    }
    remove(context, data) {
        const accepted = this._checkBounds(data);
        if (accepted.length == 0) {
            return;
        }
        if (this.items) {
            const removeSet = new Set(accepted);
            const kept = this.items.data.filter((item) => !removeSet.has(item));
            if (kept.length !== this.items.data.length) {
                this.items.data = kept;
            }
        }
        if (this.children) {
            for (const c of this.children) {
                c.remove(context, accepted);
            }
        }
    }
}
//# sourceMappingURL=tree.spatial.node.js.map